const LOCAL_ORIGIN = "https://woods.local";

export function isSafeLocalReturnPath(value: string | null | undefined): value is string {
  if (!value || !value.startsWith("/") || value.startsWith("//")) return false;
  try {
    return new URL(value, LOCAL_ORIGIN).origin === LOCAL_ORIGIN;
  } catch {
    return false;
  }
}

export function appendReturnTo(href: string, returnTo: string): string {
  if (!isSafeLocalReturnPath(href) || !isSafeLocalReturnPath(returnTo)) return href;
  const target = new URL(href, LOCAL_ORIGIN);
  target.searchParams.set("returnTo", returnTo);
  return `${target.pathname}${target.search}${target.hash}`;
}

export function readSafeReturnTo(search: string): string | null {
  const returnTo = new URLSearchParams(search).get("returnTo");
  return isSafeLocalReturnPath(returnTo) ? returnTo : null;
}
